import React, { useRef, useState } from 'react';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import Heading from '../../components/common/Heading/Heading';
import {
  App,
  Button,
  Card,
  DatePicker,
  Dropdown,
  Flex,
  Input,
  Popconfirm,
  Popover,
  Space,
  Table,
  Tag,
} from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { FaAddressCard } from 'react-icons/fa';
import { LuTimerReset } from 'react-icons/lu';

import { useNavigate } from 'react-router-dom';
import {
  cancelAppointments,
  deleteAppointments,
  getAppointments,
  updateAppointmentsWorkflow,
} from '../../network/appointment';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { DownOutlined } from '@ant-design/icons';
import { ModalAppRescheduleAppointment } from '../../components/upeosoft/ModalApp/ModalApp';
import { colorPrimary, getTimeFormat } from '../../utils/utils';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import StatusTag from '../../hooks/StatusHook';
import { TiCancel } from 'react-icons/ti';
const Appointments = ({ t }) => {
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const client = useQueryClient();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [openModalReschedule, setOpenModalReschedule] = useState(false);
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const [status, setStatus] = useState('');
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [selectName, setSelectName] = useState('');
  const { RangePicker } = DatePicker;

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText({ value: selectedKeys[0], key: dataIndex });
  };
  const handleReset = (clearFilters, confirm) => {
    confirm();
    setTextValue('');
    clearFilters();
    setSearchText({ value: '', key: '' });
  };
  const { mutate: updateAppointmentStatus, isLoading: loadingUpdateStatus } =
    useMutation({
      mutationFn: (status) => updateAppointmentsWorkflow(status),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message || []);
        client.invalidateQueries({ queryKey: [queryKeys.getAppointments] });
      },
      onError: (error) => {
        console.log(error, 'error');
      },
    });
  const { mutate: updateAppointmentStatusCancel } = useMutation({
    mutationFn: (status) => updateAppointmentsWorkflow(status),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      onCancelAppointment(selectName);
      message.success(data?.message?.message || []);
      client.invalidateQueries({ queryKey: [queryKeys.getAppointments] });
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { mutate: onCancelAppointment } = useMutation({
    mutationFn: (name) => cancelAppointments(name),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      client.invalidateQueries({
        queryKey: [queryKeys.getAppointments, searchText.key, searchText.value],
      });
      // message.success("Cancelled successfully");
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getAppointments, searchText.key, searchText.value],
    queryFn: () =>
      getAppointments({ key: searchText.key, value: searchText.value }),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteAppointments(id),
      onSuccess: (data) => {
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        //  message.success('تم الحذف بنجاح');
        client.invalidateQueries({
          queryKey: [queryKeys.getAppointments],
        });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const cancel = (e) => {
    console.log(e);
    // message.error('تم الغاء العملية');
  };

  const items = [
    {
      key: '1',
      label: (
        // status?.workflow_state === 'Scheduled' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Scheduled'}
          onClick={() =>
            updateAppointmentStatus({ record: status?.name, status: 'Confirm' })
          }
        >
          {t.confirm}
        </Button>
      ),
      // ),
    },

    {
      key: '2',
      label: (
        // status?.workflow_state === 'Scheduled' && (
        <Button
          type="text"
          size="small"
          disabled={
            status?.workflow_state === 'Scheduled'
              ? false
              : status?.workflow_state === 'Confirmed'
              ? false
              : true
          }
          onClick={
            () => {
              updateAppointmentStatusCancel({
                record: status?.name,
                status: 'Cancel',
              });
              setSelectName(status?.name);
            }
            // updateAppointmentStatus({
            //   record: status?.name,
            //   status: 'Cancel',
            // })
            // onCancelAppointment(status?.name)
          }
        >
          {t.Cancel}
        </Button>
      ),
    },

    {
      key: '3',
      label: (
        // status?.workflow_state === 'Confirmed' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Confirmed'}
          onClick={() =>
            updateAppointmentStatus({
              record: status?.name,
              status: 'Pending',
            })
          }
          loading={loadingUpdateStatus}
        >
          {t.pending}
        </Button>
      ),
      // ),
    },

    {
      key: '4',
      label: (
        // status?.workflow_state === 'Confirmed' && (
        <Button
          size="small"
          type="text"
          disabled={status?.workflow_state !== 'Confirmed'}
          onClick={() =>
            updateAppointmentStatus({
              record: status?.name,
              status: 'Check In',
            })
          }
        >
          {t.checkIn}
        </Button>
      ),
      // ),
    },
    {
      key: '5',
      label: (
        // status?.workflow_state === 'Pending to complete patient file' && (
        <Button
          type="text"
          size="small"
          disabled={
            status?.workflow_state !== 'Pending to complete patient file'
          }
          onClick={() =>
            updateAppointmentStatus({
              record: status?.name,
              status: 'Check In',
            })
          }
        >
          {t.checkIn}
        </Button>
      ),
      // ),
    },
    {
      key: '6',
      label: (
        // status?.workflow_state === 'Checked In' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Checked In'}
          onClick={() =>
            updateAppointmentStatus({
              record: status?.name,
              status: 'Open',
            })
          }
        >
          {t.open}
        </Button>
      ),
      // ),
    },
    {
      key: '7',
      label: (
        // status?.workflow_state === 'Open' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Open'}
          onClick={() =>
            updateAppointmentStatus({
              record: status?.name,
              status: 'Checked Out',
            })
          }
        >
          {t.checkedOut}
        </Button>
      ),
      // ),
    },
  ];

  const columns = [
    {
      title: t.patientID,
      dataIndex: 'patient',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'patient')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'patient')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/appointments/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.patient,
      dataIndex: 'patient_name',
      // filteredValue: [searchText],
      // onFilter: (value, record) => {
      //   const name = String(record.patient_name).toLowerCase();
      //   const date = String(record.appointment_date).toLowerCase();
      //   const pract = String(record.practitioner_name).toLowerCase();
      //   const searchValue = value.toLowerCase();
      //   return name.includes(searchValue) || date.includes(searchValue) || pract.includes(searchValue);
      // },
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, 'patient_name')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleSearch(selectedKeys, confirm, 'patient_name')
              }
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.mobile,
      dataIndex: 'custom_mobile',
      render: (text) => (
        <a href={`tel:${text}`} className="text-ltr">
          {text}
        </a>
      ),
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, 'custom_mobile')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleSearch(selectedKeys, confirm, 'custom_mobile')
              }
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.appointmentDate,
      dataIndex: 'appointment_date',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {/* <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'date')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          /> */}
          <Flex vertical gap={16}>
            <DatePicker
              onChange={(date) => {
                console.log(date, 'e.target.value');
                // console.log(e, 'e.target.value');
                console.log(
                  dayjs(date)?.format('YYYY-MM-DD'),
                  'appointment_date'
                );
                if (date) {
                  setSearchText({
                    value: dayjs(date)?.format('YYYY-MM-DD'),
                    key: 'appointment_date',
                  });
                } else {
                  setSearchText({ value: '', key: '' });
                }
                // setSelectedKeys(e?.target?.value ? [e?.target?.value] : []);
                // setTextValue(e?.target?.value);
              }}
            />
            {/* <Space>
              <Button
                type="primary"
                // onClick={() => handleSearch(selectedKeys, confirm, 'date')}
                // icon={<SearchOutlined />}
                size="small"
                style={{
                  width: 90,
                }}
              >
                {t.submit}
              </Button>
              <Button
                onClick={() =>
                  clearFilters && handleReset(clearFilters, confirm)
                }
                size="small"
                style={{
                  width: 90,
                }}
              >
                {t.Reset}
              </Button>
            </Space> */}
          </Flex>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.appointmentTime,
      dataIndex: 'appointment_time',
      render: (time) => {
        return <Tag color={colorPrimary}>{getTimeFormat(time)}</Tag>;
      },
    },
    {
      title: t.practitioner,
      dataIndex: 'practitioner_name',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, 'practitioner_name')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleSearch(selectedKeys, confirm, 'practitioner_name')
              }
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    // {
    //   title: t.practitionerName,
    //   dataIndex: 'practitioner_name',
    // },
    {
      title: t.department,
      dataIndex: 'department',
      with: 80,
      ellipsis: true,
    },
    {
      title: t.appointmentType,
      dataIndex: 'appointment_type',
    },
    {
      title: t.status,
      dataIndex: 'workflow_state',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        const enableEdit =
          record?.workflow_state === 'Scheduled' ||
          record?.workflow_state === 'Confirmed';

        // record?.workflow_state === 'Checked In' ||
        // record?.workflow_state === 'Open';
        return (
          <Space>
            {enableEdit ? (
              <Popover
                placement="top"
                title={t.edit}
                onClick={() => navigate(`/appointments/${record.name}`)}
              >
                <Button size="small" type="primary">
                  <MdModeEditOutline />
                </Button>
              </Popover>
            ) : (
              <Button
                size="small"
                type="primary"
                style={{ visibility: 'hidden' }}
              >
                <MdModeEditOutline />
              </Button>
            )}
            {/* {
              enableEdit &&
              <Popconfirm
              title={t.canceltheAppointment}
              description={t.AreyousuretoCancelthisappointment}
              onConfirm={() => onCancelAppointment(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
              >
              <Button size="small" type="primary" danger
               icon={<TiCancel />}
              />
            </Popconfirm>
            } */}
            <Popconfirm
              title={t.DeletetheAppointment}
              description={t.Areyousuretodeletethisappointment}
              onConfirm={() => handleRemove.mutate(record.name)}
              onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
            {record?.workflow_state === 'Open' && (
              <Popover
                placement="top"
                title={t.addAnEncounter}
                onClick={() =>
                  navigate(`/encounters/appointment/add/${record.name}`)
                }
              >
                <Button size="small" type="primary">
                  <FaAddressCard />
                </Button>
              </Popover>
            )}

            {enableEdit && (
              <Popover
                placement="top"
                title={t.RescheduleAppointment}
                onClick={() => {
                  setEditId(record?.name);
                  setEdit(true);
                  setOpenModalReschedule(true);
                }}
              >
                <Button
                  size="small"
                  style={{
                    background: '#108ee9',
                  }}
                >
                  <LuTimerReset color="white" />
                </Button>
              </Popover>
            )}
          </Space>
        );
      },
    },
    {
      title: t.changeStatus,
      dataIndex: 'change status',
      render: (text, record) => {
        return (
          <Space>
            <Dropdown
              menu={{ items }}
              trigger={['click']}
              arrow
              onClick={() => setStatus(record)}
            >
              <Button size="small" type="text" className="btn-light">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="appointments">
      <Heading title={t.Healthcare} subTitle={t.appointments} path="/" />
      <Card>
        <Flex
          align="center"
          justify="space-between"
          fullWidth
          style={{ marginBottom: 20 }}
        >
          <Space size="middle">
            <Button
              type="primary"
              ghost
              onClick={() =>
                setSearchText({
                  value: dayjs().format('YYYY-MM-DD'),
                  key: 'appointment_date',
                })
              }
            >
              {t.todayAppointments}
            </Button>
            <Button
              ghost
              type="primary"
              onClick={() =>
                setSearchText({
                  value: dayjs().add(1, 'day').format('YYYY-MM-DD'),
                  key: 'appointment_date',
                })
              }
            >
              {t.tomorrowAppointments}
            </Button>
          </Space>
          <Button type="primary" onClick={() => navigate(`/appointments/add`)}>
            <PlusOutlined size={10} /> {t.addAppointment}
          </Button>
        </Flex>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataTable}
          // pagination={true}
          scroll={{ x: 'max-content' }}
          // className="table"
          loading={isLoading}
          rowKey="key"
          pagination={true}
        />
      </Card>
      <ModalAppRescheduleAppointment
        open={openModalReschedule}
        setOpen={setOpenModalReschedule}
        t={t}
        editId={editId}
        edit={edit}
      />
    </div>
  );
};

export default Appointments;
